import React from "react";
import "./TemplateListItem.scss";
import Highlighter from "react-highlight-words";

export interface TemplateListItemProps {
  id: string | number;
  title: string;
  description?: string;
  isSelected: boolean;
  onClick: (id: string | number) => void;
  searchValue: string;
}

const TemplateListItem: React.FC<TemplateListItemProps> = ({
  id,
  title,
  description,
  isSelected,
  onClick,
  searchValue,
}) => {
  return (
    <div
      className={`template-item-wrapper ${isSelected ? "selected" : ""}`}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        onClick(id);
        e.stopPropagation();
      }}
    >
      <div className={"template-name"}>
        <Highlighter
          highlightClassName={"highlight-text-wrap"}
          searchWords={[searchValue]}
          autoEscape={true}
          textToHighlight={title}
        />
      </div>
      {description && (
        <div className={"template-description"}>{description}</div>
      )}
    </div>
  );
};
export default TemplateListItem;
